const defaultFacebookAccount = {
  name: '',
  facebookId: '',
  accessToken: '',
  businessId: '',
  appId: '',
  catalogId: '',
  pixelId: '',
  adAccountId: '',
  backendTracking: false,
  enabledTrackingEvents: [],
  countries: [],
  productSyncSchedule: `${parseInt(Math.random() * 59)} ${parseInt(Math.random() * 23)} * * *`,
  facebookEnabled: true,
  advantagePlusCreativeEnabled: true,
  useSkuAsItemGroupId: false,
  useExternalCatalog: false,
};

export default defaultFacebookAccount;
